export default __webpack_public_path__ + "static/media/recycle-bin-2--remove-delete-empty-bin-trash-garbage.b52464e3.svg";